import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { selectEntryDataIsComplete } from 'src/features/tax-coupon/TaxCouponSelectors'
import { actions } from 'src/features/tax-coupon/TaxCouponState'
import { useDockData } from 'src/hooks/useDockData'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import * as S from './TaxCouponEntryForm.styles'
import { EntryData } from '../../../../TaxCouponTypes'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export default () => {
  const dispatch = useDispatch()
  const currentDock = useDockData()
  const entryDataIsComplete = useSelector(selectEntryDataIsComplete)

  const { fc } = useFulfillmentCenter()

  const {
    getValues, handleSubmit, register, formState: { errors },
  } = useForm<EntryData>({
    defaultValues: { dock: currentDock?.id },
  })

  const onSubmit = () => dispatch(actions.validateEntryData({ ...getValues(), idFc: fc.id }))

  return (
    <S.EntryForm onSubmit={handleSubmit(onSubmit)}>
      <S.InputContainer>
        <S.Input
          label='taxCoupon'
          name='taxCoupon'
          id='taxCoupon'
          disabled={entryDataIsComplete}
          inputProps={{ ...register('taxCoupon', { required: 'Campo obrigatório' }), 'data-testid': 'taxcoupon-test' }}
          error={!!errors.taxCoupon}
          helperText={errors.taxCoupon?.message}
          autoComplete='off'
        />

        <S.Input
          label='taxCouponDate'
          name='couponDate'
          id='couponDate'
          disabled={entryDataIsComplete}
          type='date'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            ...register('couponDate', { required: 'Campo obrigatório', validate: { atMostToday: (v) => dayjs(v) <= dayjs() || 'Data futura inválida' } }),
            'data-testid': 'coupondate-test',
            max: dayjs().format('YYYY-MM-DD'),
          }}
          error={!!errors.couponDate}
          helperText={errors.couponDate?.message}
          autoComplete='off'
        />

        <S.Input
          label='badge'
          name='userBadge'
          id='userBadge'
          inputProps={{ ...register('userBadge', { required: 'Campo obrigatório' }), 'data-testid': 'badge-test' }}
          error={!!errors.userBadge}
          helperText={errors.userBadge?.message}
          type='password'
          disabled={entryDataIsComplete}
          autoComplete='off'
        />

        <S.Input
          label='supplier.queue.table.header.dock'
          name='dock'
          defaultValue={currentDock?.id}
          disabled
        />

        <S.ButtonSubmit
          disabled={entryDataIsComplete}
          title='Iniciar'
          type='submit'
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
        />
      </S.InputContainer>
    </S.EntryForm>
  )
}
